/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef } from "react";
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP 사업장 전기실 관리 - 초기 화면 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
//component
function NoZoneView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentPopWin = props.setPopWin;
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    useEffect(() => {
        setParentPopWin("pop-area-right-page-info", React.createElement(MobileNoZoneView, null));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right", ref: mobileRef },
            React.createElement("p", { className: "txt-ready" },
                React.createElement("span", null, "\uC0AC\uC5C5\uC7A5\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.")))));
}
;
export default NoZoneView;
function MobileNoZoneView(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "area__right_content workplace__info" },
                React.createElement("p", { className: "txt-ready" },
                    React.createElement("span", null, "\uC0AC\uC5C5\uC7A5\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694."))))));
}
